import { SortFilter } from 'components/Filters/SortFilter';
import { useCurrentUser } from 'lib/contexts/ApplicationState';
import { useUserLists } from 'lib/contexts/userListsContext';
import { userIsTeamMember, userIsAdmin } from 'lib/helpers';
import { CreatorSort } from 'lib/types/filters';
import { pickBy } from 'lodash';
import { creatorSortOptions } from 'server/api/services/creatorSearch/constants';
import { CreatorSearchCriteria } from 'server/api/services/creatorSearch/types';

interface Props {
  criteria: CreatorSearchCriteria | undefined;
}

export const CreatorsSort = ({ criteria }: Props) => {
  const { lists } = useUserLists();
  const currentUser = useCurrentUser();

  const getExtraSortOptions = (): Record<string, string> | undefined => {
    if (criteria?.list && lists?.find((l) => l?.publicId === criteria?.list)?.teamId) {
      const extraOptions: Record<string, string> = {
        votes: 'Most Upvotes',
        submissionDate: 'Date Added to List',
      };
      if (userIsTeamMember(currentUser) || userIsAdmin(currentUser)) {
        extraOptions.followers = 'Most Followers';
      }
      return extraOptions;
    }

    if (criteria?.list) {
      return {
        submissionDate: 'Date Added to List',
      };
    }

    if (userIsTeamMember(currentUser) || userIsAdmin(currentUser)) {
      return {
        followers: 'Most Followers',
      };
    }

    return undefined;
  };

  return (
    <SortFilter<CreatorSort>
      sortOptions={pickBy(
        creatorSortOptions, (v, k) => !['votes', 'submissionDate'].includes(k),
      )}
      sort={criteria?.sort}
      defaultSort={criteria?.list ? 'submissionDate' : 'mostRecentCredit'}
      extraOptions={getExtraSortOptions()}
    />
  );
};
